import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { BootScene } from "../../BootScene";
import { BoardScene } from "../BoardScene";

export class PuckValuesContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT - 50 * GameVars.scaleY;


        this.scaleY = GameVars.scaleY;

        const redPuck = new Phaser.GameObjects.Image(this.scene, -100, 0, "texture_atlas_1", "puck-red");
        redPuck.setScale(.8);
        this.add(redPuck);

        const carromEngine = GameVars.carromEngine;

        const redPuckValueLabel = new Phaser.GameObjects.Text(this.scene, -65, 0 + (BootScene.textYgap * -40), carromEngine.pucksValues.red.toString(), { fontFamily: "Teko-Medium", fontSize: "35px", color: "#FFFFFF" });
        redPuckValueLabel.setOrigin(.5,BootScene.originY);
        redPuckValueLabel.setShadow(0, 2, "#061f55", 0, false, true);
        this.add(redPuckValueLabel);

        const whitePuck = new Phaser.GameObjects.Image(this.scene, -18, 0, "texture_atlas_1", "puck-white");
        whitePuck.setScale(.8);
        this.add(whitePuck);

        const whitePuckValueLabel = new Phaser.GameObjects.Text(this.scene, 17, 0 + (BootScene.textYgap * -40), carromEngine.pucksValues.white.toString(), { fontFamily: "Teko-Medium", fontSize: "35px", color: "#FFFFFF" });
        whitePuckValueLabel.setOrigin(.5,BootScene.originY);
        whitePuckValueLabel.setShadow(0, 2, "#061f55", 0, false, true);
        this.add(whitePuckValueLabel);

        const blackPuck = new Phaser.GameObjects.Image(this.scene, 60, 0, "texture_atlas_1", "puck-black");
        blackPuck.setScale(.8);
        this.add(blackPuck);

        const blackPuckValueLabel = new Phaser.GameObjects.Text(this.scene, 95, 0 + (BootScene.textYgap * -40), carromEngine.pucksValues.black.toString(), { fontFamily: "Teko-Medium", fontSize: "35px", color: "#FFFFFF" });
        blackPuckValueLabel.setOrigin(.5,BootScene.originY);
        blackPuckValueLabel.setShadow(0, 2, "#061f55", 0, false, true);
        this.add(blackPuckValueLabel);
    }
}
